
import { api_url } from './ConfigApp'
import axios from 'axios'







// axios.defaults.headers.common = { 'Authorization': `Bearer ${User_Info.jwt_Token_User}`, 'Content-Type': 'application/json; charset=utf-8' }


axios.defaults.timeout = 60 * 10 * 1000;;

export function xhrPost(data, url, progressEvent, errorEvent, doneEvent, requestReference, jwt_Token_User) {

    try {
        const xhr = new XMLHttpRequest();

        xhr.open("POST", `${api_url}${url}`)
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Authorization', 'Bearer ' + jwt_Token_User)

        xhr.upload.addEventListener('progress', progressEvent)
        xhr.addEventListener('error', errorEvent)
        xhr.addEventListener('load', () => {
            if (xhr.status == 200)
                doneEvent(xhr.response)
            else
                errorEvent(xhr.status)
        })

        if (requestReference) {
            requestReference(xhr)
        }

        xhr.send(JSON.stringify(data))
    } catch (e) {
        errorEvent(e)
    }

}

export function GetApi(endpoint, jwt_Token_User) {

    axios.defaults.headers.common['Authorization'] = `Bearer ${jwt_Token_User}`;
    return new Promise(function (resolve) {
        axios.get(`${api_url}${endpoint}`)
            .then(function (json) {


                resolve(json.data);

            }).catch(error => {
                //console.log(error);

            })

    });

}

export function PostApi(endpoint, data, jwt_Token_User = null) {


    axios.defaults.headers.common['Authorization'] = `Bearer ${jwt_Token_User}`;
    return new Promise(function (resolve) {
        axios.post(`${api_url}${endpoint}`, data, { headers: { 'Content-type': 'application/json; charset=utf-8' } })
            .then(function (json) {

                resolve(json.data);

            }).catch(error => {
                //console.log(error);
            })

    });

}